import { Action } from '@ngrx/store';

export enum ActionTypes {
    CHECK_DOWNLOAD = '[Media] Downlad Media PIxabay',
    NUMBER = '[Media] Selected Number',
    RESETSTATE = '[Media] Reset State',
    EDITID = '[Media] Edit Id',
    HIDESEARCHBAR = '[Media] Media Search Bar '
}

export class CheckDownloaf implements Action {
    readonly type = ActionTypes.CHECK_DOWNLOAD;

    constructor(public download : any) { }
}

export class MediaEditId implements Action {
    readonly type = ActionTypes.EDITID;

    constructor(public editId : any) { }
}

export class HideSearchBar implements Action {
    readonly type = ActionTypes.HIDESEARCHBAR;
}

export class Checknumber implements Action {
    readonly type = ActionTypes.NUMBER;

    constructor(public  selected : number) { }
}
export class ResetNumber implements Action {
    readonly type = ActionTypes.RESETSTATE;

}

export type Actions
    = CheckDownloaf | Checknumber | ResetNumber | MediaEditId